import React from 'react';
import ContactCard from './ContactCard';

const Contacts = ({ contacts }) => {
  return (
    <>
      <div className="contact-info">
        {contacts.map(contact => (
          <ContactCard key={contact.id} contact={contact} />
        ))}
      </div>
      <div className="map-container">
        <div className="map-labels">
          <a 
            href="https://yandex.ru/maps/11184/nefteugansk/" 
            className="map-link map-link-top"
            target="_blank" 
            rel="noopener noreferrer"
          >
            Нефтеюганск
          </a>
          <a 
            href="https://yandex.ru/maps/11184/nefteugansk/house/13_y_mikrorayon_7/Y0sYcAVkTEMOQFhrfXx2eXhnbQ==/" 
            className="map-link map-link-bottom"
            target="_blank" 
            rel="noopener noreferrer"
          >
            13-й микрорайон, 7 — Яндекс Карты
          </a>
        </div>
        <iframe
          title="Карта офиса КПРФ в Нефтеюганске"
          src="https://yandex.ru/map-widget/v1/?l=sat%2Cskl&ll=72.623422%2C61.078375&mode=whatshere&whatshere%5Bpoint%5D=72.624693%2C61.078428&whatshere%5Bzoom%5D=17&z=19"
          className="map-iframe"
          allowFullScreen
        />
      </div>
      <div className="map-open-link">
  <a 
    href="https://yandex.ru/maps/11184/nefteugansk/?ll=72.623422%2C61.078375&z=19" 
    target="_blank" 
    rel="noopener noreferrer"
    className="btn-outline"
  >
    Открыть карту в Яндекс.Картах ↗
  </a>
</div>
    </>
    
  );
};

export default Contacts;